<template>
  <b-card>
    <b-card-title class="d-flex justify-content-between">
      <div>Genel Bilgi</div>
      <div>
        <b-form-checkbox
          :checked="detailForm"
          name="check-button"
          switch
          inline
          @change="detailToggle"
        >
          Detaylı Bilgi
        </b-form-checkbox>
      </div>
    </b-card-title>
    <b-row>
      <b-col cols="12">
        <customer-type />
      </b-col>
      <b-col cols="12">
        <company />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <name />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <phone />
      </b-col>
      <b-col cols="12">
        <phone-alert />
      </b-col>
      <b-col
        v-if="detailForm"
        cols="12"
        md="6"
      >
        <phone2 />
      </b-col>
      <b-col
        v-if="detailForm"
        cols="12"
        md="6"
      >
        <fax />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <email />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <sector />
      </b-col>
      <b-col
        v-if="detailForm"
        cols="12"
      >
        <notes />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BRow, BCol, BCard, BCardTitle, BFormCheckbox,
} from 'bootstrap-vue'
import CustomerType from '@/views/Customers/elements/CustomerType.vue'
import Company from '@/views/Customers/elements/Company.vue'
import Name from '@/views/Customers/elements/Name.vue'
import Phone from '@/views/Customers/elements/Phone.vue'
import PhoneAlert from '@/views/Customers/elements/PhoneAlert.vue'
import Phone2 from '@/views/Customers/elements/Phone2.vue'
import Fax from '@/views/Customers/elements/Fax.vue'
import Email from '@/views/Customers/elements/Email.vue'
import Sector from '@/views/Customers/elements/Sector.vue'

import Notes from '@/views/Customers/elements/Notes.vue'

export default {
  name: 'CustomerForm',
  components: {
    BRow,
    BCol,
    BCard,
    BCardTitle,
    BFormCheckbox,
    CustomerType,
    Company,
    Name,
    Phone,
    PhoneAlert,
    Phone2,
    Fax,
    Email,
    Sector,
    Notes,
  },
  computed: {
    detailForm() {
      return this.$store.getters['customers/detailForm']
    },
  },
  methods: {
    detailToggle() {
      this.$store.commit('customers/SET_DETAIL_FORM', !this.detailForm)
    },
  },
}
</script>
